export default __webpack_public_path__ + "static/media/Akira_Bold.fd0b2b86.ttf";